import { formatPrice } from '@/composables/useCartMutation'

/**
 * Resolves membership pricing for a product given the customer's membership tier.
 *
 * @param {Object} product - Product from the V2 store endpoint (must include membership_prices, price_cents, price_formatted)
 * @param {string|number|null} membershipTierId - The customer's current membership tier ID
 * @returns {Object|null} Resolved pricing info, or null if no membership discount applies
 */
export function resolveMembershipPricing(product, membershipTierId) {
  if (!membershipTierId) return null

  const entry = (product.membership_prices || []).find(
    (mp) => String(mp.membership_tier_id) === String(membershipTierId)
  )

  if (!entry) return null
  if (!entry.available_for_membership_tier) return null
  if (entry.use_default_price) return null
  if (entry.price_cents === product.price_cents) return null

  const currency = product.price_formatted?.currency_iso || 'USD'

  return {
    shouldStrikeThrough: entry.price_cents < product.price_cents,
    defaultPriceFormatted: product.price_formatted?.format,
    membershipPriceFormatted: entry.price_formatted?.format || formatPrice(entry.price_cents, currency),
    membershipPriceCents: entry.price_cents
  }
}
